import { QueryClient } from '@tanstack/react-query'

/**
 * The TanStack Query client. Sane defaults for a data-dense CRM: a 60s stale
 * time so list views don't refetch on every navigation, a 10-minute GC window
 * so back/forward keeps warm caches, one retry, and no refetch on focus or
 * reconnect (the SSE/AppSync delta channel keeps the cache fresh - see
 * lib/sse-client.ts).
 *
 * In mock mode the dispatcher runs `capability.mock` against the MockStore; MSW
 * would mount here if any module made raw SDK calls (none do in PLAN-00 - every
 * mutation flows through the dispatcher).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
})
